import { ReactNode, lazy, Suspense } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import BreadcrumbSchema from "./BreadcrumbSchema";
import HomepageSchema from "./HomepageSchema";

const FaqChatWidget = lazy(() => import("./FaqChatWidget"));

const Layout = ({ children }: { children: ReactNode }) => (
  <div className="flex min-h-screen flex-col overflow-x-hidden">
    <Navbar />
    <BreadcrumbSchema />
    <HomepageSchema />
    <main className="flex-1">{children}</main>
    <Footer />
    <Suspense fallback={null}>
      <FaqChatWidget />
    </Suspense>
  </div>
);

export default Layout;
